import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=de77b892&scoped=true&"
import script from "./goodsDetail.vue?vue&type=script&lang=js&"
export * from "./goodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsDetail.vue?vue&type=style&index=0&id=de77b892&prod&lang=less&scoped=true&"
import style1 from "./goodsDetail.vue?vue&type=style&index=1&id=de77b892&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de77b892",
  null
  
)

export default component.exports